<template>
  <div class="recommend-by">
    <span ref="recommend-by-box" class="recommend-by-box">
      <img :src="avatarPic" alt="" class="avatarPic">
      <span
        ref="userName"
        :class="[
          'userName',
          { 'scrollShow': scrollShow }
        ]"
      >{{ userName }}
        <span v-if="scrollShow" v-html="space"></span>
      </span>
      <span
        v-if="scrollShow"
        :class="[
          'userName',
          { 'scrollShow': scrollShow }
        ]"
      >{{ userName }}
        <span v-html="space"></span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    avatarPic: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      scrollShow: false,
      space: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
    }
  },
  mounted () {
    this.scrollShow = this.$refs['userName'].offsetWidth > this.$refs['recommend-by-box'].offsetWidth
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
